"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirflowApi = exports.AirflowApiFactory = exports.AirflowApiFp = exports.AirflowApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AirflowApi - axios parameter creator
 * @export
 */
const AirflowApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} dagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetAirflowTaskTIsLink: (dagId_1, ...args_1) => __awaiter(this, [dagId_1, ...args_1], void 0, function* (dagId, options = {}) {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowTaskResourceGetAirflowTaskTIsLink', 'dagId', dagId);
            const localVarPath = `/airflow/dag/{dagId}/graph-link`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetAirflowTasksInfo: (dagId_2, ...args_2) => __awaiter(this, [dagId_2, ...args_2], void 0, function* (dagId, options = {}) {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowTaskResourceGetAirflowTasksInfo', 'dagId', dagId);
            const localVarPath = `/airflow/dag/{dagId}/task-infos`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetAirflowTiLogLink: (dagId_3, taskId_1, ...args_3) => __awaiter(this, [dagId_3, taskId_1, ...args_3], void 0, function* (dagId, taskId, options = {}) {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowTaskResourceGetAirflowTiLogLink', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('airflowTaskResourceGetAirflowTiLogLink', 'taskId', taskId);
            const localVarPath = `/airflow/dag/{dagId}/{taskId}/ti-log-link`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {string} [xAirflowVersion]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetTaskConfig: (dagId_4, taskId_2, xAirflowVersion_1, ...args_4) => __awaiter(this, [dagId_4, taskId_2, xAirflowVersion_1, ...args_4], void 0, function* (dagId, taskId, xAirflowVersion, options = {}) {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowTaskResourceGetTaskConfig', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('airflowTaskResourceGetTaskConfig', 'taskId', taskId);
            const localVarPath = `/airflow/dag/{dagId}/{taskId}/jobConfig`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xAirflowVersion != null) {
                localVarHeaderParameter['X-Airflow-Version'] = String(xAirflowVersion);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {number} [calcPeriod]
         * @param {number} [calcTimestamp]
         * @param {string} [xAirflowVersion]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetTaskData: (dagId_5, taskId_3, calcPeriod_1, calcTimestamp_1, xAirflowVersion_2, body_1, ...args_5) => __awaiter(this, [dagId_5, taskId_3, calcPeriod_1, calcTimestamp_1, xAirflowVersion_2, body_1, ...args_5], void 0, function* (dagId, taskId, calcPeriod, calcTimestamp, xAirflowVersion, body, options = {}) {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowTaskResourceGetTaskData', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('airflowTaskResourceGetTaskData', 'taskId', taskId);
            const localVarPath = `/airflow/dag/{dagId}/{taskId}/getJobData`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (calcPeriod !== undefined) {
                localVarQueryParameter['calcPeriod'] = calcPeriod;
            }
            if (calcTimestamp !== undefined) {
                localVarQueryParameter['calcTimestamp'] = calcTimestamp;
            }
            if (xAirflowVersion != null) {
                localVarHeaderParameter['X-Airflow-Version'] = String(xAirflowVersion);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {number} [calcPeriod]
         * @param {number} [calcTimestamp]
         * @param {string} [xAirflowVersion]
         * @param {AirflowTaskOutputData} [airflowTaskOutputData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourcePostTaskData: (dagId_6, taskId_4, calcPeriod_2, calcTimestamp_2, xAirflowVersion_3, airflowTaskOutputData_1, ...args_6) => __awaiter(this, [dagId_6, taskId_4, calcPeriod_2, calcTimestamp_2, xAirflowVersion_3, airflowTaskOutputData_1, ...args_6], void 0, function* (dagId, taskId, calcPeriod, calcTimestamp, xAirflowVersion, airflowTaskOutputData, options = {}) {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowTaskResourcePostTaskData', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('airflowTaskResourcePostTaskData', 'taskId', taskId);
            const localVarPath = `/airflow/dag/{dagId}/{taskId}/postJobData`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (calcPeriod !== undefined) {
                localVarQueryParameter['calcPeriod'] = calcPeriod;
            }
            if (calcTimestamp !== undefined) {
                localVarQueryParameter['calcTimestamp'] = calcTimestamp;
            }
            if (xAirflowVersion != null) {
                localVarHeaderParameter['X-Airflow-Version'] = String(xAirflowVersion);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(airflowTaskOutputData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AirflowApiAxiosParamCreator = AirflowApiAxiosParamCreator;
/**
 * AirflowApi - functional programming interface
 * @export
 */
const AirflowApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AirflowApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} dagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetAirflowTaskTIsLink(dagId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowTaskResourceGetAirflowTaskTIsLink(dagId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AirflowApi.airflowTaskResourceGetAirflowTaskTIsLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetAirflowTasksInfo(dagId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowTaskResourceGetAirflowTasksInfo(dagId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AirflowApi.airflowTaskResourceGetAirflowTasksInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetAirflowTiLogLink(dagId, taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowTaskResourceGetAirflowTiLogLink(dagId, taskId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AirflowApi.airflowTaskResourceGetAirflowTiLogLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {string} [xAirflowVersion]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetTaskConfig(dagId, taskId, xAirflowVersion, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowTaskResourceGetTaskConfig(dagId, taskId, xAirflowVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AirflowApi.airflowTaskResourceGetTaskConfig']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {number} [calcPeriod]
         * @param {number} [calcTimestamp]
         * @param {string} [xAirflowVersion]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetTaskData(dagId, taskId, calcPeriod, calcTimestamp, xAirflowVersion, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowTaskResourceGetTaskData(dagId, taskId, calcPeriod, calcTimestamp, xAirflowVersion, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AirflowApi.airflowTaskResourceGetTaskData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {number} [calcPeriod]
         * @param {number} [calcTimestamp]
         * @param {string} [xAirflowVersion]
         * @param {AirflowTaskOutputData} [airflowTaskOutputData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourcePostTaskData(dagId, taskId, calcPeriod, calcTimestamp, xAirflowVersion, airflowTaskOutputData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowTaskResourcePostTaskData(dagId, taskId, calcPeriod, calcTimestamp, xAirflowVersion, airflowTaskOutputData, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AirflowApi.airflowTaskResourcePostTaskData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AirflowApiFp = AirflowApiFp;
/**
 * AirflowApi - factory interface
 * @export
 */
const AirflowApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AirflowApiFp)(configuration);
    return {
        /**
         *
         * @param {AirflowApiAirflowTaskResourceGetAirflowTaskTIsLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetAirflowTaskTIsLink(requestParameters, options) {
            return localVarFp.airflowTaskResourceGetAirflowTaskTIsLink(requestParameters.dagId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AirflowApiAirflowTaskResourceGetAirflowTasksInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetAirflowTasksInfo(requestParameters, options) {
            return localVarFp.airflowTaskResourceGetAirflowTasksInfo(requestParameters.dagId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AirflowApiAirflowTaskResourceGetAirflowTiLogLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetAirflowTiLogLink(requestParameters, options) {
            return localVarFp.airflowTaskResourceGetAirflowTiLogLink(requestParameters.dagId, requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AirflowApiAirflowTaskResourceGetTaskConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetTaskConfig(requestParameters, options) {
            return localVarFp.airflowTaskResourceGetTaskConfig(requestParameters.dagId, requestParameters.taskId, requestParameters.xAirflowVersion, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AirflowApiAirflowTaskResourceGetTaskDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourceGetTaskData(requestParameters, options) {
            return localVarFp.airflowTaskResourceGetTaskData(requestParameters.dagId, requestParameters.taskId, requestParameters.calcPeriod, requestParameters.calcTimestamp, requestParameters.xAirflowVersion, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AirflowApiAirflowTaskResourcePostTaskDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowTaskResourcePostTaskData(requestParameters, options) {
            return localVarFp.airflowTaskResourcePostTaskData(requestParameters.dagId, requestParameters.taskId, requestParameters.calcPeriod, requestParameters.calcTimestamp, requestParameters.xAirflowVersion, requestParameters.airflowTaskOutputData, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AirflowApiFactory = AirflowApiFactory;
/**
 * AirflowApi - object-oriented interface
 * @export
 * @class AirflowApi
 * @extends {BaseAPI}
 */
class AirflowApi extends base_1.BaseAPI {
    /**
     *
     * @param {AirflowApiAirflowTaskResourceGetAirflowTaskTIsLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirflowApi
     */
    airflowTaskResourceGetAirflowTaskTIsLink(requestParameters, options) {
        return (0, exports.AirflowApiFp)(this.configuration).airflowTaskResourceGetAirflowTaskTIsLink(requestParameters.dagId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AirflowApiAirflowTaskResourceGetAirflowTasksInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirflowApi
     */
    airflowTaskResourceGetAirflowTasksInfo(requestParameters, options) {
        return (0, exports.AirflowApiFp)(this.configuration).airflowTaskResourceGetAirflowTasksInfo(requestParameters.dagId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AirflowApiAirflowTaskResourceGetAirflowTiLogLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirflowApi
     */
    airflowTaskResourceGetAirflowTiLogLink(requestParameters, options) {
        return (0, exports.AirflowApiFp)(this.configuration).airflowTaskResourceGetAirflowTiLogLink(requestParameters.dagId, requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AirflowApiAirflowTaskResourceGetTaskConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirflowApi
     */
    airflowTaskResourceGetTaskConfig(requestParameters, options) {
        return (0, exports.AirflowApiFp)(this.configuration).airflowTaskResourceGetTaskConfig(requestParameters.dagId, requestParameters.taskId, requestParameters.xAirflowVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AirflowApiAirflowTaskResourceGetTaskDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirflowApi
     */
    airflowTaskResourceGetTaskData(requestParameters, options) {
        return (0, exports.AirflowApiFp)(this.configuration).airflowTaskResourceGetTaskData(requestParameters.dagId, requestParameters.taskId, requestParameters.calcPeriod, requestParameters.calcTimestamp, requestParameters.xAirflowVersion, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AirflowApiAirflowTaskResourcePostTaskDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirflowApi
     */
    airflowTaskResourcePostTaskData(requestParameters, options) {
        return (0, exports.AirflowApiFp)(this.configuration).airflowTaskResourcePostTaskData(requestParameters.dagId, requestParameters.taskId, requestParameters.calcPeriod, requestParameters.calcTimestamp, requestParameters.xAirflowVersion, requestParameters.airflowTaskOutputData, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AirflowApi = AirflowApi;
//# sourceMappingURL=airflow-api.js.map